import { createAction, props } from '@ngrx/store';

// Inicia el historial de los proyectos abiertos'.
export const clean = createAction('[HISTORY] Reiniciar historial');

// Añade un nodo al camino.
export const update = createAction('[HISTORY] Actualizar', props<{ lastProjects: any[] }>());

